import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCheck, FiZap, FiShield, FiUsers, FiStar, FiActivity } = FiIcons;

const StepCard = ({ number, title, sub, desc }) => (
  <div className="bg-[#0B0E14] border border-gray-800 rounded-2xl p-5 mb-4 flex items-start gap-4 hover:border-gray-700 transition-colors">
    <div className="flex-shrink-0 w-8 h-8 bg-white rounded-full flex items-center justify-center text-black font-bold text-sm">
      {number}
    </div>
    <div className="text-left">
      <h3 className="text-white font-bold text-lg leading-tight">{title}</h3>
      <p className="text-gray-400 text-sm mt-1 leading-snug">
        {sub} <span className="text-gray-500">{desc}</span>
      </p>
    </div>
  </div>
);

const TrustPill = ({ icon, text, colorClass = "text-white" }) => (
  <div className="border border-gray-800 rounded-full py-3 px-4 flex items-center justify-center gap-2 bg-[#0B0E14] hover:bg-gray-900 transition-colors">
    <SafeIcon icon={icon} className={`${colorClass} text-lg`} />
    <span className="text-white font-semibold text-sm">{text}</span>
  </div>
);

const LandingClone = () => {
  return (
    <div className="min-h-screen bg-black text-white font-sans flex flex-col items-center py-16 px-4 selection:bg-white selection:text-black">
      
      {/* Header Section */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-center w-full max-w-md mx-auto mb-10"
      >
        <h1 className="text-5xl font-extrabold mb-6 tracking-tight">Quit Today</h1>
        
        <div className="inline-flex items-center gap-2 bg-white text-black px-6 py-2 rounded-full font-bold text-sm mb-10 shadow-[0_0_15px_rgba(255,255,255,0.2)]">
          <SafeIcon icon={FiCheck} /> Recovery Community
        </div>

        <h2 className="text-2xl font-bold mb-2">Quit your addiction today</h2>
        <p className="text-gray-400 font-medium">by following these easy steps</p>
      </motion.div>

      {/* Steps Section */}
      <motion.div 
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1 }}
        className="w-full max-w-md mx-auto text-center"
      >
        <div className="flex flex-col items-center mb-8">
          <div className="flex items-center gap-2 text-white font-bold mb-2 uppercase tracking-widest text-xs opacity-70">
            <SafeIcon icon={FiZap} /> 3 Easy Steps
          </div>
          <div className="w-12 h-0.5 bg-gray-800"></div>
        </div>

        <div className="space-y-4">
          <StepCard 
            number="1"
            title="Click To Change Your Life"
            sub="Hit the button below →"
            desc="Begin your journey to quitting porn"
          />
          
          <StepCard 
            number="2"
            title="Download QUITTR App"
            sub="Get our partner app QUITTR -"
            desc="quit your addiction today"
          />
          
          <StepCard 
            number="3"
            title="Build Healthy Habits"
            sub="By following our comprehensive guide"
            desc="your life will begin to change"
          />
        </div>

        {/* Pro Tip Box */}
        <div className="bg-[#0B0E14] border border-gray-800 rounded-2xl p-5 my-8 text-left relative overflow-hidden group">
          <div className="absolute top-0 right-0 w-24 h-24 bg-white/5 blur-3xl rounded-full -mr-10 -mt-10 group-hover:bg-white/10 transition-all"></div>
          <div className="flex items-center gap-2 text-white font-bold mb-2">
            <SafeIcon icon={FiZap} className="text-yellow-400" /> PRO TIP: Maximize Results
          </div>
          <p className="text-gray-400 text-sm leading-relaxed relative z-10">
            Signup for the free trial to gain access to a whole world of change.
          </p>
        </div>

        {/* CTA Button */}
        <motion.button 
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          className="w-full bg-white text-black rounded-full py-5 font-black text-xl flex items-center justify-center gap-2 hover:bg-gray-100 transition-all shadow-[0_10px_30px_rgba(255,255,255,0.1)] mb-6"
        >
          <SafeIcon icon={FiCheck} /> Change Your Life Today
        </motion.button>

        <p className="text-gray-500 text-xs font-bold uppercase tracking-widest mb-10">50K+ members recovering daily</p>

        {/* Trust Badges Grid */}
        <div className="grid grid-cols-2 gap-3 w-full">
          <TrustPill icon={FiShield} text="100% Secure" colorClass="text-green-500" />
          <TrustPill icon={FiActivity} text="Healthy Habits" colorClass="text-blue-500" />
          <TrustPill icon={FiUsers} text="50K+ Users" colorClass="text-purple-500" />
          <TrustPill icon={FiStar} text="4.7★ Rating" colorClass="text-yellow-500" />
        </div>

      </motion.div>

      {/* Footer */}
      <footer className="mt-16 text-gray-600 text-[10px] uppercase tracking-[0.2em] font-bold">
        © 2024 Quitter App • Path to Freedom
      </footer>
    </div>
  );
};

export default LandingClone;